import state from '@/taskpane/state/sidebar-state'
import storage from '@/taskpane/common/local-storage'
import MessageArgs from '../messages/message-args'
import { showLoginPopup } from '@/taskpane/graph/generated/fallbackauthdialog'
import configuration from '@/taskpane/common/configuration'

interface GraphLoginRequestCallbackArgs extends MessageArgs {
  accept: boolean
  block: boolean
}

export default async function graphLoginRequestCallbackHandler(data: GraphLoginRequestCallbackArgs) {
  if (data.accept) {
    state.resetGraphAccessAlertFlag()
    showLoginPopup()
  } else {
    state.currentItem.apiInfo.isGraphApiAvailable = false

    if (data.block) {
      storage.setLocalItem(configuration.IGNORE_GRAPH_LOGIN_FLAG, 'true')
    }
  }
}
